import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalPrivateChannelListener } from "~/components/Hooks/useGlobalPrivateChannelListener";
import { fetchUserTasks } from "~/store/actions/actions.tasks";
import { getAllTaskLists } from "~/store/selectors/selector.taskLists";
import { getLoggedUserId } from "~/store/selectors/selector.users";

/**
 * The problem: User is assigned to the task (realtime), but not have task list in state
 * @param {Number} userId
 */
export const useUserTasksRealtime = (userId) => {
  const loggedUserId = useSelector(getLoggedUserId);
  let forId = userId ? Number(userId) : loggedUserId;
  const taskLists = useSelector(getAllTaskLists);
  const dispatch = useDispatch();

  const refetch = useCallback(
    (task) => {
      if (task.task_list_id && !taskLists.get(`${task.task_list_id}`) && task.assignee_id === forId) {
        dispatch(fetchUserTasks(forId));
      }
    },
    [dispatch, forId, taskLists]
  );

  useGlobalPrivateChannelListener("TaskCreated", refetch);
  useGlobalPrivateChannelListener("TaskUpdated", refetch);
  useGlobalPrivateChannelListener("TaskMovedToProject", refetch);
  useGlobalPrivateChannelListener("TaskRestoredFromTrash", refetch);
};
